import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type UserFragment = { id: string, name?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null };


export type UserFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const UserFragmentDoc = /*#__PURE__*/ gql`
    fragment User on UserType {
  id
  name
  uniqueId
  emailId
  profilePicture
  orgRole {
    id
    name
  }
}
    `;